import React, { useEffect } from "react";

const InfoCard = ({ heading, text, cards, columns = 3 }) => {
  const columnsClass = {
    1: "grid-cols-1",
    2: "grid-cols-2",
    3: "lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1",
    4: "grid-cols-4",
    5: "grid-cols-5",
    6: "grid-cols-6",
  };
  const lgColumns = columnsClass[columns];
  useEffect(() => {
    console.log("Cards Loaded: ", cards);
  });

  return (
    <div className="container max-w-[1152px] mx-auto md:mx-4 lg:mx-auto my-12">
      {/* <marquee width="100%" direction="left" height="40px">
        <p className="text-3xl font-semibold">This is a sample Headline.</p>
      </marquee> */}
      {/* Left Side Layout */}
      <div className="w-full py-2 ml-4 sm:ml-0">
        <h2 className="text-2xl font-bold mb-4">{heading}</h2>
        <p className="text-gray-700">{text}</p>
      </div>

      {/* Cards Section */}
      <div className={`w-full grid ${lgColumns} gap-4 py-2`}>
        {cards.map((post, index) => (
          <div
            key={index}
            className="rounded-lg shadow-lg p-4 flex flex-col items-start"
          >
            <BlogCard post={post} />
          </div>
        ))}
      </div>
    </div>
  );
};

function BlogCard({ post }) {
  // Helper function to truncate text to a specific word count
  const truncateText = (text, wordLimit) => {
    const words = text.split(" ");
    return words.length > wordLimit
      ? words.slice(0, wordLimit).join(" ") + "..."
      : text;
  };

  // Fallback logic for description
  const getDescription = () => {
    if (post.description) {
      return post.description;
    }
    if (post.sections && post.sections.length > 0) {
      // Check the first section
      if (post.sections[0].content) {
        return post.sections[0].content;
      }
      // Check the second section if the first has no content
      if (post.sections.length > 1 && post.sections[1].content) {
        return post.sections[1].content;
      }
    }
    return "No description available.";
  };

  // Fallback logic for featured image
  const getFeaturedImage = () => {
    if (post.featuredImage) {
      return post.featuredImage;
    }
    if (post.sections && post.sections.length > 0) {
      // Find the first section with an image
      const sectionWithImage = post.sections.find((section) => section.image);
      if (sectionWithImage) {
        return sectionWithImage.image;
      }
    }
    // Default image if no featured image or section image is available
    return "assets/images/default-blog-image.jpg";
  };

  return (
    <>
      <img
        src={getFeaturedImage()}
        alt={post.title}
        className="w-auto h-64 object-cover mb-4 rounded-t-lg"
      />
      <h3 className="text-lg font-semibold mb-2">{post.title}</h3>
      <p className="text-gray-600">{truncateText(getDescription(), 20)}</p>
      <div className="flex items-center mt-4">
        <a
          href={`/blogs/${post.slug}`}
          className="bg-teal-600 text-white px-4 py-2 rounded-lg flex items-center"
        >
          Read More →
        </a>
      </div>
    </>
  );
}

export default InfoCard;
